const CHUNK_RELOAD_STORAGE_KEY = 'backoffice-chunk-reload';

const CHUNK_LOAD_ERROR_PATTERN = /Loading chunk [\w-]+ failed|ChunkLoadError|Unexpected token '<'/i;

export { CHUNK_RELOAD_STORAGE_KEY };

export function isChunkLoadError(error) {
  if (!error) return false;

  const message = error?.message || String(error);

  if (CHUNK_LOAD_ERROR_PATTERN.test(message)) {
    return true;
  }

  return (
    message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed')
    || message.includes('error loading dynamically imported module')
  );
}

export function recoverFromChunkLoadError(
  targetPath = `${window.location.pathname}${window.location.search}`,
) {
  const lastReloadPath = sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY);

  if (lastReloadPath === targetPath) {
    sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
    return false;
  }

  sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, targetPath);
  window.location.assign(targetPath);
  return true;
}

export function clearChunkReloadFlag() {
  sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
}
